export enum MarkerCategory {
  Pump = 0,
  Sensor = 1,
  Field = 2,
  Pivot = 3
}
